import React from "react";
import { useTranslation } from "react-i18next";

function EnterpriseIntro() {
    const { t } = useTranslation();

    return (
        <section className="EnterpriseIntro">
            <div className="inner-wrapper">
                {/* <h2>{t("EntIntroTitle")}</h2> */}

                {/* <div className="video-wrapper">
                    <iframe
                        src="https://www.youtube.com/embed/9TD3qFObwms"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                </div> */}

                {/* <div className="desc">
                    <p>{t("EntIntroDesc")}</p>
                </div> */}

                {/* <div className="button-wrapper">
                    <div className="btn freeTrialBtn">
                        <a href="/register">Start your Free trial</a>
                    </div>
                </div> */}

                {/* <div className="finePrnt">
                    <ul>
                        <li>Customizable to your preferences</li>
                        <li>Try free trial today</li>
                        <li>All-in-one software</li>
                    </ul>
                </div> */}
            </div>
        </section>
    );
}

export default EnterpriseIntro;
